

import store from '../config/store'

export default {
  components: {
    'operation-detail': () => import(/* webpackChunkName: "sidepanels" */ '@/common/components/sidepanels/OperationDetail.vue'),
    'operation-export': () => import(/* webpackChunkName: "sidepanels" */ '@/common/components/sidepanels/OperationExport.vue'),
    'new-beneficiary': () => import(/* webpackChunkName: "sidepanels" */ '@/common/components/sidepanels/NewBeneficiary.vue'),
    'edit-multiple-transfer': () => import(/* webpackChunkName: "sidepanels" */ '@/common/components/sidepanels/EditMultipleTransfer.vue'),
    'transfer-detail': () => import(/* webpackChunkName: "sidepanels" */ '@/common/components/sidepanels/TransferDetail.vue'),
    'top-up-detail': () => import(/* webpackChunkName: "modals" */ '@/common/components/sidepanels/TopUpDetail.vue'),
    'top-up-prepaid-card': () => import(/* webpackChunkName: "modals" */ '@/common/components/sidepanels/TopUpPrepaidCard.vue'),
    'edit-recurring-top-up': () => import(/* webpackChunkName: "modals" */ '@/common/components/sidepanels/EditRecurringTopUp.vue'),
  },

  data: () => ({
    store
  })
}
